/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdoptFormMigrationResultDto } from '../models/AdoptFormMigrationResultDto';
import type { EntityFormInWorkflowDefinition } from '../models/EntityFormInWorkflowDefinition';
import type { FormDefinition } from '../models/FormDefinition';
import type { FormElementWithAnswerCountDto } from '../models/FormElementWithAnswerCountDto';
import type { MoveAnswersRequestDto } from '../models/MoveAnswersRequestDto';
import type { MoveAnswersResultDto } from '../models/MoveAnswersResultDto';
import type { WorkflowDefinition } from '../models/WorkflowDefinition';
import type { WorkflowDefinitionListDto } from '../models/WorkflowDefinitionListDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class WorkflowDefinitionService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get all workflow definitions from the DB.
     * @param orgGuid
     * @returns WorkflowDefinitionListDto OK
     * @throws ApiError
     */
    public getAllWorkflowDefinitionDtos(
        orgGuid?: string,
    ): CancelablePromise<Array<WorkflowDefinitionListDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/WorkflowDefinition/GetAllWorkflowDefinitionDtos',
            query: {
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get a single workflow definition by its guid.
     * @param guid
     * @param orgGuid
     * @returns WorkflowDefinition OK
     * @throws ApiError
     */
    public getWorkflowDefinition(
        guid: string,
        orgGuid: string,
    ): CancelablePromise<WorkflowDefinition> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/WorkflowDefinition/{guid}/{orgGuid}/GetWorkflowDefinition',
            path: {
                'guid': guid,
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Create a new workflow definition
     * @param requestBody
     * @returns WorkflowDefinition OK
     * @throws ApiError
     */
    public createWorkflowDefinition(
        requestBody?: WorkflowDefinition,
    ): CancelablePromise<WorkflowDefinition> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/WorkflowDefinition/CreateWorkflowDefinition',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Create a new form definition in a workflow definition
     * @param workflowDefinitionGuid
     * @param formName
     * @param isCreatingWorkflowStep
     * @returns FormDefinition OK
     * @throws ApiError
     */
    public createWorkflowDefinitionForm(
        workflowDefinitionGuid?: string,
        formName?: string,
        isCreatingWorkflowStep?: boolean,
    ): CancelablePromise<FormDefinition> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/WorkflowDefinition/CreateWorkflowDefinitionForm',
            query: {
                'workflowDefinitionGuid': workflowDefinitionGuid,
                'formName': formName,
                'isCreatingWorkflowStep': isCreatingWorkflowStep,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Retrieves all form definitions that are not associated with any workflow definition.
     * These are "orphaned" forms that exist in the system but don't belong to a workflow.
     * @param orgGuid The organization GUID to filter forms by.
     * @returns FormDefinition OK
     * @throws ApiError
     */
    public getOrphanedFormDefinitions(
        orgGuid: string,
    ): CancelablePromise<Array<FormDefinition>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/WorkflowDefinition/{orgGuid}/GetOrphanedFormDefinitions',
            path: {
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Adopts an orphaned form into a workflow definition by setting its WorkflowDefinitionGuid.
     * This associates an existing form (that has no workflow) with the specified workflow definition.
     * WARNING: This only updates the form's WorkflowDefinitionGuid. Any existing form responses
     * for this form will NOT be automatically linked to workflow instances. A separate migration
     * strategy must be implemented to handle existing form responses.
     * @param workflowDefinitionGuid The workflow definition to adopt the form into.
     * @param formDefinitionGuid The form definition to adopt.
     * @returns AdoptFormMigrationResultDto OK
     * @throws ApiError
     */
    public adoptFormIntoWorkflow(
        workflowDefinitionGuid: string,
        formDefinitionGuid: string,
    ): CancelablePromise<AdoptFormMigrationResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/WorkflowDefinition/{workflowDefinitionGuid}/{formDefinitionGuid}/AdoptFormIntoWorkflow',
            path: {
                'workflowDefinitionGuid': workflowDefinitionGuid,
                'formDefinitionGuid': formDefinitionGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Finds all form responses in this workflow definition that don't have a workflow instance
     * and creates one for each. Safe to re-run — already-linked responses are skipped.
     * @param workflowDefinitionGuid
     * @param dryRun
     * @returns AdoptFormMigrationResultDto OK
     * @throws ApiError
     */
    public syncFormsToWorkflows(
        workflowDefinitionGuid: string,
        dryRun: boolean = false,
    ): CancelablePromise<AdoptFormMigrationResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/WorkflowDefinition/{workflowDefinitionGuid}/SyncFormsToWorkflows',
            path: {
                'workflowDefinitionGuid': workflowDefinitionGuid,
            },
            query: {
                'dryRun': dryRun,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Update an existing workflow definition.
     * @param guid The GUID of the workflow definition to update.
     * @param requestBody The updated details.
     * @returns WorkflowDefinition OK
     * @throws ApiError
     */
    public updateWorkflowDefinition(
        guid: string,
        requestBody?: WorkflowDefinition,
    ): CancelablePromise<WorkflowDefinition> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/WorkflowDefinition/{guid}/UpdateWorkflowDefinition',
            path: {
                'guid': guid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Delete an existing workflow definition.
     * @param guid The item's guid.
     * @param orgGuid
     * @returns boolean OK
     * @throws ApiError
     */
    public deleteWorkflowDefinition(
        guid: string,
        orgGuid?: string,
    ): CancelablePromise<boolean> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/WorkflowDefinition/{guid}/DeleteWorkflowDefinition',
            path: {
                'guid': guid,
            },
            query: {
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get all entity form configurations for a workflow definition.
     * @param workflowDefinitionGuid
     * @returns EntityFormInWorkflowDefinition OK
     * @throws ApiError
     */
    public getEntityFormsInWorkflowDefinition(
        workflowDefinitionGuid: string,
    ): CancelablePromise<Array<EntityFormInWorkflowDefinition>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/WorkflowDefinition/{workflowDefinitionGuid}/GetEntityFormsInWorkflowDefinition',
            path: {
                'workflowDefinitionGuid': workflowDefinitionGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Add an entity form to a workflow definition.
     * This allows the entity definition's form to appear as a step within the workflow.
     * When filled out, it can automatically create a new entity.
     * @param workflowDefinitionGuid
     * @param entityDefinitionGuid
     * @param requestBody
     * @returns EntityFormInWorkflowDefinition OK
     * @throws ApiError
     */
    public addEntityFormToWorkflowDefinition(
        workflowDefinitionGuid: string,
        entityDefinitionGuid: string,
        requestBody?: EntityFormInWorkflowDefinition,
    ): CancelablePromise<EntityFormInWorkflowDefinition> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/WorkflowDefinition/{workflowDefinitionGuid}/{entityDefinitionGuid}/AddEntityFormToWorkflowDefinition',
            path: {
                'workflowDefinitionGuid': workflowDefinitionGuid,
                'entityDefinitionGuid': entityDefinitionGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Update an entity form configuration in a workflow definition.
     * @param entityFormGuid
     * @param requestBody
     * @returns EntityFormInWorkflowDefinition OK
     * @throws ApiError
     */
    public updateEntityFormInWorkflowDefinition(
        entityFormGuid: string,
        requestBody?: EntityFormInWorkflowDefinition,
    ): CancelablePromise<EntityFormInWorkflowDefinition> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/WorkflowDefinition/{entityFormGuid}/UpdateEntityFormInWorkflowDefinition',
            path: {
                'entityFormGuid': entityFormGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Remove an entity form from a workflow definition.
     * @param entityFormGuid
     * @returns any OK
     * @throws ApiError
     */
    public removeEntityFormFromWorkflowDefinition(
        entityFormGuid: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/WorkflowDefinition/{entityFormGuid}/RemoveEntityFormFromWorkflowDefinition',
            path: {
                'entityFormGuid': entityFormGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Update the list of questions to show for a workflow definition.
     * @param guid The GUID of the workflow definition to update.
     * @param requestBody The updated details.
     * @returns WorkflowDefinition OK
     * @throws ApiError
     */
    public updateWorkflowDefinitionListing(
        guid: string,
        requestBody?: WorkflowDefinition,
    ): CancelablePromise<WorkflowDefinition> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/WorkflowDefinition/{guid}/UpdateWorkflowDefinitionListing',
            path: {
                'guid': guid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param workflowDefinitionGuid
     * @returns FormElementWithAnswerCountDto OK
     * @throws ApiError
     */
    public getFormElementsWithAnswers(
        workflowDefinitionGuid: string,
    ): CancelablePromise<Array<FormElementWithAnswerCountDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/WorkflowDefinition/{workflowDefinitionGuid}/GetFormElementsWithAnswers',
            path: {
                'workflowDefinitionGuid': workflowDefinitionGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param workflowDefinitionGuid
     * @param requestBody
     * @returns MoveAnswersResultDto OK
     * @throws ApiError
     */
    public moveAnswers(
        workflowDefinitionGuid: string,
        requestBody?: MoveAnswersRequestDto,
    ): CancelablePromise<MoveAnswersResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/WorkflowDefinition/{workflowDefinitionGuid}/MoveAnswers',
            path: {
                'workflowDefinitionGuid': workflowDefinitionGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
